/**
 * 存储localStorage
 */
function set(name,content) {
	if (!name) return
	if (typeof content !== 'string') {
	  content = JSON.stringify(content)
	}
	window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
function get(name) {
	if (!name) return
	return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
function remove(name) {
	if (!name) return
	window.localStorage.removeItem(name)
}


export default {
  set,
  get,
  remove
};
